<template>
  <div class="row">
    <div class="col-12">
      <div class="col-block">
        <div class="block-header has-border">
          <h3>
            <strong>續存作業</strong>
          </h3>
        </div>
        <div class="block-content">
          <el-form
            label-position="top"
            label-width="80px"
            :model="recordToEdit"
            :rules="rules"
            ref="recordToEdit"
          >
            <el-form-item label="銀行名稱">
              <el-select
                v-model="recordToEdit.coopBankId"
                placeholder="請選擇銀行"
                disabled
              >
                <el-option
                  v-for="item in enumData.bank"
                  :key="item.id"
                  :label="item.bankName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="存單號碼">
              <el-input v-model="recordToEdit.accountNumber"></el-input>
            </el-form-item>
            <el-form-item label="存款計息方式">
              <el-select
                v-model="recordToEdit.interestCalcFiexd"
                placeholder="請選擇"
              >
                <el-option
                  v-for="item in interestMethod"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="存款年利率">
              <el-input v-model="recordToEdit.annualInterestRate"></el-input>
            </el-form-item>
            <el-form-item label="續存日期">
              <div class="date">
                <input
                  type="text"
                  class="min_go_date startDate"
                  placeholder="選擇日期"
                />
                <span class="el-input__prefix">
                  <i class="el-icon-date"></i>
                </span>
              </div>
            </el-form-item>
            <el-form-item label="存款月數">
              <el-input v-model="recordToEdit.depositMonth"></el-input>
            </el-form-item>
            <el-form-item label="到期日期">
              <div class="date">
                <input
                  type="text"
                  class="min_go_date endDate"
                  placeholder="選擇日期"
                  disabled
                />
                <span class="el-input__prefix">
                  <i class="el-icon-date"></i>
                </span>
              </div>
              <el-button type="primary" class="ml10" plain
                >建立提醒工作</el-button
              >
            </el-form-item>
            <el-form-item label="印鑑名稱">
              <el-input v-model="recordToEdit.sealName"></el-input>
            </el-form-item>
            <el-form-item label="保管人姓名">
              <el-input v-model="recordToEdit.custodian"></el-input>
            </el-form-item>
            <el-form-item label="備註">
              <el-input
                v-model="recordToEdit.note"
                type="textarea"
                :rows="4"
              ></el-input>
            </el-form-item>
            <div class="line"></div>
            <el-form-item label="本金金額">
              <el-input v-model="recordToEdit.amount" disabled></el-input>
            </el-form-item>
            <el-form-item label="利息金額">
              <el-input
                v-model="interestAmount"
                @change="getVoucher"
              ></el-input>
            </el-form-item>
            <el-radio
              v-model="earlyDisEffectiveVoucher"
              label="noAccruedInterestDt"
              >本金續存(未加計利息)</el-radio
            >
            <table class="table table-bordered mb-0">
              <thead class="grey lighten-4">
                <tr>
                  <th>收款日期</th>
                  <th>科目代號</th>
                  <th>科目名稱</th>
                  <th>借方金額</th>
                  <th>貸方金額</th>
                  <th>摘要</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td :rowspan="currentEdit.noAccruedInterestDt.details.length">
                    {{
                      currentEdit.noAccruedInterestDt.main.tradeDate
                        | datechange
                    }}
                  </td>
                  <td>
                    {{
                      currentEdit.noAccruedInterestDt.details[0]
                        .accountTitleCode
                    }}
                  </td>
                  <td>
                    {{
                      currentEdit.noAccruedInterestDt.details[0]
                        .accountTitleName
                    }}
                  </td>
                  <td>
                    {{
                      $addcomma(
                        currentEdit.noAccruedInterestDt.details[0].debitAmount
                      )
                    }}
                  </td>
                  <td>
                    {{
                      $addcomma(
                        currentEdit.noAccruedInterestDt.details[0].creditAmount
                      )
                    }}
                  </td>
                  <td>
                    <el-input
                      v-model="
                        currentEdit.noAccruedInterestDt.details[0].summary
                      "
                    ></el-input>
                  </td>
                </tr>
                <tr
                  v-for="(detail, idx) in currentEdit.noAccruedInterestDt
                    .details"
                  v-if="idx > 0"
                >
                  <td>{{ detail.accountTitleCode }}</td>
                  <td>{{ detail.accountTitleName }}</td>
                  <td>{{ $addcomma(detail.debitAmount) }}</td>
                  <td>{{ $addcomma(detail.creditAmount) }}</td>
                  <td>
                    <el-input v-model="detail.summary"></el-input>
                  </td>
                </tr>
              </tbody>
            </table>
            <el-radio
              v-model="earlyDisEffectiveVoucher"
              label="accruedInterestDt"
              >本息續存(加計利息)</el-radio
            >
            <table class="table table-bordered mb-0">
              <thead class="grey lighten-4">
                <tr>
                  <th>收款日期</th>
                  <th>科目代號</th>
                  <th>科目名稱</th>
                  <th>借方金額</th>
                  <th>貸方金額</th>
                  <th>摘要</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td :rowspan="currentEdit.accruedInterestDt.details.length">
                    {{
                      currentEdit.accruedInterestDt.main.tradeDate | datechange
                    }}
                  </td>
                  <td>
                    {{
                      currentEdit.accruedInterestDt.details[0].accountTitleCode
                    }}
                  </td>
                  <td>
                    {{
                      currentEdit.accruedInterestDt.details[0].accountTitleName
                    }}
                  </td>
                  <td>
                    {{
                      $addcomma(
                        currentEdit.accruedInterestDt.details[0].debitAmount
                      )
                    }}
                  </td>
                  <td>
                    {{
                      $addcomma(
                        currentEdit.accruedInterestDt.details[0].creditAmount
                      )
                    }}
                  </td>
                  <td>
                    <el-input
                      v-model="currentEdit.accruedInterestDt.details[0].summary"
                    ></el-input>
                  </td>
                </tr>
                <tr
                  v-for="(detail, idx) in currentEdit.accruedInterestDt.details"
                  v-if="idx > 0"
                >
                  <td>{{ detail.accountTitleCode }}</td>
                  <td>{{ detail.accountTitleName }}</td>
                  <td>{{ $addcomma(detail.debitAmount) }}</td>
                  <td>{{ $addcomma(detail.creditAmount) }}</td>
                  <td>
                    <el-input v-model="detail.summary"></el-input>
                  </td>
                </tr>
              </tbody>
            </table>
            <el-button class="mt10" type="primary" @click="saveData"
              >建立新存單並產生傳票</el-button
            >
            <el-button @click="back">取消</el-button>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { API } from "@/assets/config";
import moment from "moment";
export default {
  name: "deposit_order_summons_continue",

  data() {
    return {
      id: this.$route.params.id,
      toDay: "",
      recordToEdit: {},
      interestMethod: [],
      rules: {
        name: [
          {
            required: true,
            message: "請輸入方案名稱",
            trigger: "blur",
          },
        ],
        code: [
          {
            required: true,
            message: "請輸入方案代碼",
            trigger: "blur",
          },
        ],
      },
      enumData: {},
      // 傳票資訊
      currentEdit: {
        main: {
          tradeDate: "",
          voucherCode: "",
          note: "",
          createTime: "",
          createName: "",
        },
        details: [{}],
        noAccruedInterestDt: {
          main: {
            tradeDate: "",
            voucherCode: "",
            note: "",
            createTime: "",
            createName: "",
          },
          details: [{}],
        },
        accruedInterestDt: {
          main: {
            tradeDate: "",
            voucherCode: "",
            note: "",
            createTime: "",
            createName: "",
          },
          details: [{}],
        },
      },
      // 利息金額
      interestAmount: 0,
      // 中途解約傳票 radio
      earlyDisEffectiveVoucher: "noAccruedInterestDt",
    };
  },
  created() {
    // 取得續存作業資料
    this.getData();
    // 取得傳票資訊
    this.getVoucher();

    // 預設日期為今日
    setTimeout(() => {
      this.initDate();
    }, 100);
  },
  watch: {
    "recordToEdit.depositMonth"(val) {
      setTimeout(() => {
        if ($(`.startDate`).val() == "") {
          this.initDate();
        }
        this.getTime($(`.startDate`).val(), val);
      }, 100);
    },
  },
  mounted() {
    $(`.startDate`).datepicker({
      changeYear: true,
      changeMonth: true,
      currentText: "今天",
      dateFormat: "Rmmdd",
      showButtonPanel: true,
      defaultDate: null,
      onSelect: (data) => {
        setTimeout(() => {
          this.getTime(data, this.recordToEdit.depositMonth);
        }, 100);
      },
    });
  },
  methods: {
    getTime(key, num) {
      setTimeout(() => {
        this.setTime(key, num);
      }, 200);
    },
    setTime(key, num) {
      let selectTime = parseInt(key.split("-")[0]) + 1911 + key.slice(3);
      let finalDate = moment(selectTime)
        .add(Number(num), "month")
        .format("YYYY-MM-DD");
      let date = `${parseInt(finalDate) - 1911}${finalDate
        .split(" ")[0]
        .slice(4)}`;
      this.recordToEdit.endDate = finalDate;
      $(`.endDate`).val(date);
    },
    async getData() {
      const url = API.coopNtDepositOrder + `?id=${this.id}`;
      try {
        const json = await this.mAxiosGet(url);

        let newobj = {
          ...json.resultData.data,
          amount: this.$addcomma(json.resultData.data.amount),
        };
        this.recordToEdit = Object.assign({}, this.recordToEdit, newobj);
        this.enumData = Object.assign(
          {},
          this.enumData,
          json.resultData.enumData
        );
        this.interestMethod = Object.keys(
          json.resultData.enumData.interestMethod
        ).map((item) => {
          return {
            label: `${json.resultData.enumData.interestMethod[item]}`,
            value: Number(item),
          };
        });
        this.getTime(this.toDay, this.recordToEdit.depositMonth);
      } catch (error) {
        console.error("Failed getData", error);
      }
    },
    async getVoucher() {
      this.currentEdit = {
        main: {
          tradeDate: "",
          voucherCode: "",
          note: "",
          createTime: "",
          createName: "",
        },
        details: [{}],
        noAccruedInterestDt: {
          main: {
            tradeDate: "",
            voucherCode: "",
            note: "",
            createTime: "",
            createName: "",
          },
          details: [{}],
        },
        accruedInterestDt: {
          main: {
            tradeDate: "",
            voucherCode: "",
            note: "",
            createTime: "",
            createName: "",
          },
          details: [{}],
        },
      };
      var url =
        API.coopNtDepositOrder +
        `?action=reNew&id=${this.id}&interestAmount=${this.interestAmount}`;
      try {
        const json = await this.mAxiosGet(url);
        this.currentEdit = Object.assign({}, this.currentEdit, json.resultData);
      } catch (error) {
        console.error("Failed getVoucher", error);
      }
    },
    async saveData() {
      const url = API.coopNtDepositOrder + `?action=append`;
      const form = new FormData();
      const object = this.recordToEdit;

      Object.keys(object).map(function (objectKey, index) {
        if (objectKey == "amount") {
          let value = object[objectKey];
          let newValue = value.toString().replace(/,/g, "");
          form.append(objectKey, newValue !== undefined ? newValue : "");
        } else if (objectKey !== "id" && objectKey !== "preOrderId") {
          let value = object[objectKey];
          form.append(objectKey, value !== undefined ? value : "");
        }
      });
      // 新存單指回原存單，後端才認得出這張是續存建的，續存傳票被退回時要刪掉
      form.append("preOrderId", this.id);

      try {
        const json = await this.mAxiosPost(url, form);
        await this.saveVoucher(json.resultData.id);
      } catch (error) {
        console.error("Failed saveData", error);
      }
    },
    async saveVoucher(id) {
      const form = new FormData();
      const url = API.coopNtDepositOrder + `?action=createReNewVoucher`;
      var object = this.currentEdit[this.earlyDisEffectiveVoucher].main;

      form.append("depositOrderId", id);
      form.append(
        "detail",
        JSON.stringify(
          this.currentEdit[this.earlyDisEffectiveVoucher].details
        ) || ""
      );

      Object.keys(object).map(function (objectKey, index) {
        var value = object[objectKey];
        form.append(objectKey, value !== undefined ? value : "");
      });

      try {
        await this.mAxiosPost(url, form);
        this.showAjaxSuccessMsg();
      } catch (error) {
        console.error("Failed saveVoucher", error);
      }
    },
    back() {
      // 去掉最後一個 _後的詞 回到上一層
      let remove = this.$route.name.split("_");
      let name = this.$route.name.replace(`_${remove[remove.length - 1]}`, "");
      this.$router.push({ name: name });
    },
    initDate() {
      var Today = new Date();
      let Y = Today.getFullYear();
      let M = Today.getMonth() + 1;
      let D = Today.getDate();
      let A = `${Y}-${M < 10 ? "0" + M : M}-${D < 10 ? "0" + D : D}`;
      let EM = Today.getMonth() + 1;
      let E = `${Y}-${EM < 10 ? "0" + EM : EM}-${D < 10 ? "0" + D : D}`;
      this.toDay = A;
      let startDate =
        parseInt(A) - 1911 < 100
          ? `0${parseInt(A) - 1911}${A.split(" ")[0].slice(4)}`
          : `${parseInt(A) - 1911}${A.split(" ")[0].slice(4)}`;
      $(`.startDate`).val(`${startDate}`);
    },
  },
};
</script>
<style lang="scss" scoped>
.block-content {
  .box-card {
    margin-bottom: 10px;

    &:last-child {
      margin-bottom: 0;
    }

    .table {
      td {
        vertical-align: middle;
      }
    }
  }
}
</style>